import React from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Input } from "../../../../../../../../components/Form";
import useTimezoneDate from "../../../../../../../../hooks/useTimezoneDate";
import { Despatch } from "../../../../../../../../models/despatch";
import { useDespatchContext } from "../../../../context/DespatchContext";
import { DespatchSectionTitle } from "../../../components/SectionTitle";

export const DespatchTimeSection = () => {
  const { t: translate } = useTranslation();
  const { despatch, handleUpdateDespatch } = useDespatchContext();

  const { getDateValueUtcTimezone, getTimeValueUtcTimezone } = useTimezoneDate();

  const buildISOString = (year: number, month: number, day: number, timeSection: string) => {
    return `${year}-${month}-${day}T${timeSection}`;
  };

  const handleChangeDateValue = (value: any) => {
    const [year, month, day] = value.split("-");

    if (!despatch) return;

    let pickupDate = despatch?.pickupDate || new Date().toISOString();
    let deliveryDate = despatch?.deliveryDate || new Date().toISOString();

    const [, pickupTimeSection] = pickupDate.split("T");
    const [, deliveryTimeSection] = deliveryDate.split("T");

    pickupDate = buildISOString(year, month, day, pickupTimeSection);
    deliveryDate = buildISOString(year, month, day, deliveryTimeSection);

    handleUpdateDespatch("pickupDate", pickupDate);
    handleUpdateDespatch("deliveryDate", deliveryDate);
  };

  const handleChangeTimeValue = (attribute: keyof Despatch, value: string) => {
    const [hour = "00", minute = "00"] = value.split(":");

    if (!despatch) return;

    const date = despatch[attribute] ? new Date(despatch[attribute] as any) : new Date();

    date.setUTCHours(Number(hour), Number(minute));

    handleUpdateDespatch(attribute, date.toISOString());
  };

  return (
    <Grid container spacing={2}>
      <DespatchSectionTitle>{translate("time")}</DespatchSectionTitle>
      <Grid item xs={12} sm={6} md={3} lg={3}>
        <Input
          name="delivery_date"
          type="date"
          label={translate("deliveryDate")}
          value={getDateValueUtcTimezone(despatch?.deliveryDate)}
          onChange={(event) => handleChangeDateValue(event.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3} lg={3}>
        <Input
          name="pickup_time"
          type="time"
          label={translate("deliveryWindowOpen")}
          value={getTimeValueUtcTimezone(despatch?.pickupDate)}
          onChange={(event) => handleChangeTimeValue("pickupDate", event.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3} lg={3}>
        <Input
          name="delivery_time"
          type="time"
          label={translate("deliveryWindowClose")}
          value={getTimeValueUtcTimezone(despatch?.deliveryDate)}
          onChange={(event) => handleChangeTimeValue("deliveryDate", event.target.value)}
        />
      </Grid>
    </Grid>
  );
};
